import React, { useState, useEffect } from "react";
import Header from "./Header";
import GoogleAdsLandingSection from "./GoogleAdsLandingSection";
import PriceCalculatorSection from "./PriceCalculatorSection";
import BookingCalendar from "./BookingCalendar";
import ProfitecProductsSectionSimple from "./ProfitecProductsSectionSimple";
import VideoHeroSection from "./VideoHeroSection";
import HeroCarousel from "./HeroCarousel"; 
import ServiceSection from "./ServiceSection";
import DetailedServicesSection from "./DetailedServicesSection";
import ContentSection from "./ContentSection";
import SEOFAQSection from "./SEOFAQSection";
import OtherCitiesSection from "./OtherCitiesSection";
import KontaktSection from "./KontaktSection";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";
import { mockData } from "../data/mock";

const Homepage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <GoogleAdsLandingSection />
      <PriceCalculatorSection />
      <BookingCalendar />
      <ProfitecProductsSectionSimple />
      <VideoHeroSection />
      <ServiceSection />
      <KontaktSection />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Homepage;